import { Livewire, Alpine } from '../../../vendor/livewire/livewire/dist/livewire.esm';
import './bootstrap';
import.meta.glob(['../../images/**', '../../fonts/**']);

Alpine.store('globals', {
    chatClient: null,
});

window.Alpine = Alpine;
window.Livewire = Livewire;
